import { useRef } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getArtistPath } from "../utils/clubPath";

const EventArtistCaption = ({ artists }) => {
  const [isArtistModalOpened, setIsArtistModalOpen] = useState(false);
  const navigate = useNavigate()
  const dialogEl = useRef()
  function toggleArtistInfoModal() {
      if (artists?.length === 1) {
         navigate(getArtistPath(artists[0]))
      } else if (artists?.length > 1) {
         // setIsArtistModalOpen(prev => !prev)
         if(dialogEl?.current.open) {
           dialogEl?.current.close()
         } else {
           dialogEl?.current.show()
         }
      } else {

      }
  }

  function handleDialogClick(event) {
    const dialogDimensions = dialogEl?.current.getBoundingClientRect();
    console.log({ dialogDimensions })
      if (
        event.clientX < dialogDimensions.left ||
        event.clientX > dialogDimensions.right ||
        event.clientY < dialogDimensions.top ||
        event.clientY > dialogDimensions.bottom
      ) {
        dialogEl?.current.close();
      }
  }

  const imgs = Array.isArray(artists?.[0]?.images)  ? artists[0]?.images : [];
  const img = imgs?.length > 0 ? imgs[0] : null;
  return (
    <>
      {Array.isArray(artists) &&
        artists?.length ? (
        <div className="circle-img event__artist-item" onClick={toggleArtistInfoModal}>
          <img
            src={img}
            className="img-fluid circle-img-centered"
            alt="img"
          />
          <p>
            By {" "}
            <strong>
              {artists && artists[0]?.name}{" "}
              {artists?.length > 1
                ? `+${artists?.length - 1}`
                : null}
            </strong>
          </p>
        </div>
      ) : null}
      {/*<ReactModal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        className={"event-attendance-modal"}
        contentLabel="Example Modal"
      >

      </ReactModal>*/}
      <dialog ref={dialogEl} className="artistsList_modal" onClick={handleDialogClick} >
        <ol>
          {artists?.map((art, artKey) => (
            <li key={art._id}>
              <Link to={getArtistPath(art)}>
                <img src={art?.images?.[0]} alt={art?.name} />
                <span>{art.name}</span>
              </Link>
            </li>
          ))}
        </ol>
      </dialog>
    </>
  );
};

export default EventArtistCaption;
